import type { FC } from "react";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui";

import styles from "./CartLimitError.module.scss";

export type CartLimitErrorProps = {
  isCartonsLimitReached: boolean;
  isQuantityLimitReached: boolean;
  quantityLimit: number;
  className?: string;
};

export const CartLimitError: FC<CartLimitErrorProps> = ({
  isCartonsLimitReached,
  isQuantityLimitReached,
  quantityLimit,
  className,
}) => {
  const { __: translate } = useTranslations();
  return (
    <div className={className}>
      {isCartonsLimitReached && (
        <div className={styles.warning}>
          <AlertBanner
            data-testid="info-banner-wrapper"
            tone="warning"
            description={translate("cart.items.subscription_limit_reached_message_box.singleIntro")}
          />
        </div>
      )}

      {isQuantityLimitReached && (
        <div className={styles.warning}>
          <AlertBanner
            data-testid="info-banner-wrapper"
            tone="warning"
            description={`${translate("libs.ui.notification.limit.sku")} (${quantityLimit})`}
          />
        </div>
      )}
    </div>
  );
};
